const storagePrefix = 'smr-';

export const setPermanentData = (id, data) => {
    localStorage.setItem(storagePrefix + id, JSON.stringify(data));
}

export const setBrowserSessionData = (id, data) => {
    sessionStorage.setItem(storagePrefix + id, JSON.stringify(data));
}

export const getPermanentData = id => {
    return JSON.parse(localStorage.getItem(storagePrefix + id));
}

export const getBrowserSessionData = id => {
    try {
        return (JSON.parse(sessionStorage.getItem(storagePrefix + id)) && !!id) ? JSON.parse(sessionStorage.getItem(storagePrefix + id)) : false;
    } catch (e) {
        return false;
    }
}